<template>
	<span :class="clsx(className, 'flex grow basis-0 justify-end')">
		<VButton
			:href="href ? href : undefined"
			:disabled="href === null ? true : false"
			plain
			aria-label="Next page">
			{{ children }}
			<svg
				class="stroke-current"
				data-slot="icon"
				viewBox="0 0 16 16"
				fill="none"
				aria-hidden="true">
				<path
					d="M13.25 8L2.75 8M13.25 8L10.75 10.5M13.25 8L10.75 5.5"
					stroke-width="{1.5}"
					stroke-linecap="round"
					stroke-linejoin="round" />
			</svg>
		</VButton>
	</span>
</template>

<script lang="ts">
	export default { name: 'VPaginationNext' } // name the component
</script>

<script setup lang="ts">
	import VButton from '@/components/Buttons/VButton.vue'

	import { 
		clsx
	} from 'clsx'

	const props = defineProps({
		className: {
			type: String,
			default: ''
		},
		children: {
			type: String,
			default: "Next"
		},
		href: {
			type: String,
			default: null
		}
	})
</script>